<template>
  <div class="users-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              eCDC users

              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                v-if="!restrictViewUsers"
                class="btn btn-ecdc btn-shadow"
                @click="$router.push({ name: 'usersDetails' })"
              >
                Users Details
              </button>
              <button
                class="btn btn-ecdc btn-shadow"
                @click="$router.push({ name: 'teamDetails' })"
              >
                team Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                NEW USERS
                <small>{{ currentMonth }}</small>
              </h3>

              <div class="figure">
                {{ userData.newUserCount }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL TEAMS
              </h3>

              <div class="figure">
                {{ userData.teamCount }}
                <small>Teams</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL COLONIANS
              </h3>

              <div class="figure">
                {{ userData.totalColonians }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL TEAM LEADERS
              </h3>

              <div class="figure">
                {{ userData.tlCount }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL BA
              </h3>

              <div class="figure">
                {{ userData.baCount }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL RESIGNED
              </h3>

              <div class="figure">
                {{ userData.resignedUser }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                TOTAL TERMINATED
              </h3>

              <div class="figure">
                {{ userData.terminatedUser }}
                <small>Users</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  New Users By Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getUserSummaryNewUser"
                  v-model="newUserDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Area</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in newUserData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="newUserData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in newUserData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Active Users By Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getUserSummaryActiveUser"
                  v-model="activeUserDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Area</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in activeUserData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="activeUserData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in activeUserData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Active Team By Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getUserSummaryActiveTeam"
                  v-model="activeTeamDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Area</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in activeTeamData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="activeTeamData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in activeTeamData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<style scoped>
.users-summary .top-navbar .top-navbar-right button:first-child {
  margin-right: 20px;
}
</style>

<script>
import {
  getDashboardDate,
  checkPermission,
  getUserSummary,
  getUserSummaryNewUser,
  getUserSummaryActiveUser,
  getUserSummaryActiveTeam
} from "../api";
import { getProj } from "../helpers";
import Loader from "./Loader";

export default {
  components: {
    appLoader: Loader
  },

  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .day("Monday")
      .format("YYYY-MM-DD");
    const currentMonth = moment().format("MMMM YYYY");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      isLoading: true,
      currentMonth,
      projectId: getProj()["projId"],
      restrictViewUsers: false,
      weeklyDateFilter: [],
      userData: "",
      newUserData: "",
      activeUserData: "",
      activeTeamData: "",
      newUserDateDropdown: thisMonday,
      activeUserDateDropdown: thisMonday,
      activeTeamDateDropdown: thisMonday
    };
  },
  async mounted() {
    this.restrictViewUsers = await this.checkPermission("restrict users");
    await this.getDate();
    await this.getUserSummary();
    await this.getUserSummaryNewUser();
    await this.getUserSummaryActiveUser();
    await this.getUserSummaryActiveTeam();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const params = { dateType: "week" };
        const result = await getDashboardDate(params);
        this.weeklyDateFilter = result.data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async checkPermission(permission) {
      try {
        const result = await checkPermission({ permission: permission });
        return result.data.data;
      } catch (err) {
        return false;
      }
    },
    async getUserSummary() {
      try {
        let result = await getUserSummary();
        this.userData = result.data.data;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getUserSummaryNewUser() {
      try {
        let result = await getUserSummaryNewUser({
          date: this.newUserDateDropdown,
          type: "newUser"
        });
        this.newUserData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getUserSummaryActiveUser() {
      try {
        let result = await getUserSummaryActiveUser({
          date: this.activeUserDateDropdown,
          type: "activeUser"
        });
        this.activeUserData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getUserSummaryActiveTeam() {
      try {
        let result = await getUserSummaryActiveTeam({
          date: this.activeTeamDateDropdown,
          type: "activeTeam"
        });
        this.activeTeamData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    }
  }
};
</script>
